import { useState } from "react";

interface AccordionItem {
  q: string;
  a: string;
}

interface AccordionProps {
  items: AccordionItem[];
  defaultOpen?: number;
}

export default function Accordion({ items, defaultOpen = -1 }: AccordionProps) {
  const [openIndex, setOpenIndex] = useState(defaultOpen);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                aria-expanded={isOpen}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 md:px-6 md:py-5"
              >
                <span className="text-base font-medium text-foreground-950 md:text-lg">{item.q}</span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                    isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                  }`}
                  aria-hidden="true"
                >
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                </span>
              </button>
            </h3>
            {isOpen ? (
              <div className="px-5 pb-5 md:px-6 md:pb-6">
                <p className="text-sm leading-relaxed text-foreground-600 md:text-base">{item.a}</p>
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}